import { render } from "./PvpModalConfirm.vue?vue&type=template&id=84f191d4"
import script from "./PvpModalConfirm.vue?vue&type=script&lang=ts"
export * from "./PvpModalConfirm.vue?vue&type=script&lang=ts"
script.render = render

export default script